import instance from "@/utils/require.js"

// 附件管理--分页查询
export function apiArchiveSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/archive/search",
		method: "post",
		data
	})
}